/**
 * Service Worker Manager
 * Handles registration, updates, and lifecycle management
 */

let serviceWorkerRegistration = null;

export const registerServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) {
    console.log('Service Workers not supported');
    return null;
  }

  try {
    serviceWorkerRegistration = await navigator.serviceWorker.register(
      '/service-worker.js',
      {
        scope: '/',
        updateViaCache: 'none', // Always check for updates
      }
    );

    console.log('[SW Manager] Service Worker registered:', serviceWorkerRegistration);

    // Check for updates periodically
    setInterval(() => {
      if (serviceWorkerRegistration) {
        serviceWorkerRegistration.update();
      }
    }, 60000); // Check every minute

    // Listen for updates
    serviceWorkerRegistration.addEventListener('updatefound', () => {
      const newWorker = serviceWorkerRegistration.installing;
      
      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'activated' && navigator.serviceWorker.controller) {
          // New service worker is active
          window.dispatchEvent(
            new CustomEvent('sw-updated', {
              detail: { registration: serviceWorkerRegistration },
            })
          );
        }
      });
    });

    return serviceWorkerRegistration;
  } catch (error) {
    console.error('[SW Manager] Registration failed:', error);
    return null;
  }
};

export const unregisterServiceWorker = async () => {
  if (serviceWorkerRegistration) {
    const success = await serviceWorkerRegistration.unregister();
    if (success) {
      console.log('[SW Manager] Service Worker unregistered');
      serviceWorkerRegistration = null;
    }
    return success;
  }
  return false;
};

export const clearServiceWorkerCache = () => {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({ type: 'CLEAR_CACHE' });
  }
};

export const updateServiceWorker = () => {
  if (serviceWorkerRegistration) {
    serviceWorkerRegistration.update();
  }
};

export const sendMessageToServiceWorker = (message) => {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage(message);
  }
};

export const getServiceWorkerRegistration = () => {
  return serviceWorkerRegistration;
};

export const isServiceWorkerActive = () => {
  return serviceWorkerRegistration !== null && navigator.serviceWorker.controller !== null;
};
